// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAzSzznh0czZBtkc31Vlb3ZujL3HbUb8cs",
    authDomain: "bddineangular.firebaseapp.com",
    databaseURL: "https://bddineangular.firebaseio.com",
    projectId: "bddineangular",
    storageBucket: "bddineangular.appspot.com",
    messagingSenderId: "212393947821",
    appId: "1:212393947821:web:49803a9fd8fb9a03184c24",
    measurementId: "G-T6BBB4CK58"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
